'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');
var parseFieldBase = require('../parse/parseFieldBase.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function createField(fragment, callback) {
    const Field = (_param)=>{
        var { field: data } = _param, props = _object_without_properties_loose(_param, [
            "field"
        ]);
        const fieldRest = fragment ? generatedCraftcms.getFragmentData(fragment, data) : {};
        const fieldBase = parseFieldBase(data);
        const fieldData = _extends({}, fieldBase, fieldRest);
        return callback(fieldData, props);
    };
    return Field;
}

exports.createField = createField;
